// extracted by mini-css-extract-plugin
var _1 = "NotificationCountBadge-module__animatedBackground--uArqC";
var _2 = "NotificationCountBadge-module__badge--FOpBL";
var _3 = "NotificationCountBadge-module__doubleDigit--oLRIZ";
var _4 = "NotificationCountBadge-module__one--yWgkS";
var _5 = "NotificationCountBadge-module__singleDigit--aUtft";
export { _1 as "animatedBackground", _2 as "badge", _3 as "doubleDigit", _4 as "one", _5 as "singleDigit" }
